require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-jaredly-reasongl-android.json") })
        }
      }, "path---package-jaredly-reasongl-android");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-jaredly-reasongl-android!./.cache/json/package-jaredly-reasongl-android.json
// module id = 871
// module chunks = 231608221292675